var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_1200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.5C4.5 11.0304 4.71071 11.5391 5.08579 11.9142C5.46086 12.2893 5.96957 12.5 6.5 12.5C7.03043 12.5 7.53914 12.2893 7.91421 11.9142C8.28929 11.5391 8.5 11.0304 8.5 10.5C8.5 9.96957 8.28929 9.46086 7.91421 9.08579C7.53914 8.71071 7.03043 8.5 6.5 8.5C5.96957 8.5 5.46086 8.71071 5.08579 9.08579C4.71071 9.46086 4.5 9.96957 4.5 10.5Z",
    stroke: "#6366F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 4.5V8.5",
    stroke: "#6366F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.5V20.5",
    stroke: "#6366F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16.5C10.5 17.0304 10.7107 17.5391 11.0858 17.9142C11.4609 18.2893 11.9696 18.5 12.5 18.5C13.0304 18.5 13.5391 18.2893 13.9142 17.9142C14.2893 17.5391 14.5 17.0304 14.5 16.5C14.5 15.9696 14.2893 15.4609 13.9142 15.0858C13.5391 14.7107 13.0304 14.5 12.5 14.5C11.9696 14.5 11.4609 14.7107 11.0858 15.0858C10.7107 15.4609 10.5 15.9696 10.5 16.5Z",
    stroke: "#6366F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 4.5V14.5",
    stroke: "#6366F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 18.5V20.5",
    stroke: "#6366F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.5C16.5 8.03043 16.7107 8.53914 17.0858 8.91421C17.4609 9.28929 17.9696 9.5 18.5 9.5C19.0304 9.5 19.5391 9.28929 19.9142 8.91421C20.2893 8.53914 20.5 8.03043 20.5 7.5C20.5 6.96957 20.2893 6.46086 19.9142 6.08579C19.5391 5.71071 19.0304 5.5 18.5 5.5C17.9696 5.5 17.4609 5.71071 17.0858 6.08579C16.7107 6.46086 16.5 6.96957 16.5 7.5Z",
    stroke: "#6366F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 4.5V5.5",
    stroke: "#6366F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 9.5V20.5",
    stroke: "#6366F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_1200"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.e5c14013984e6daa401d20d919c0e826.svg";
export { ForwardRef as ReactComponent };